import React from 'react';
import { SlRow, SlColumn } from '@stackline/ui';
import SlSkeleton from 'src/components/BeaconV2Components/SlSkeleton/SlSkeleton';
import { BEACON_PRO_RIGHT_CONTENT_WIDTH } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';

export interface SplineChartLoadingProps {
  width?: number;
  loading?: boolean;
  includeSubtitle?: boolean;
}
const SplineChartLoading = ({ width, includeSubtitle }: SplineChartLoadingProps) => {
  const legendSkeleton = (
    <SlColumn spacing="sm">
      <SlSkeleton variant="rounded" height={23} width={68} />
      <SlSkeleton variant="rounded" height={23} width={152} />
    </SlColumn>
  );

  const subtitleSkeleton = <SlSkeleton variant="rounded" height={23} width={width || BEACON_PRO_RIGHT_CONTENT_WIDTH} />;

  return (
    <SlColumn spacing="lg">
      {includeSubtitle && subtitleSkeleton}
      <SlRow spacing="lg">
        {legendSkeleton}
        {legendSkeleton}
      </SlRow>
      <SlSkeleton variant="rounded" height={280} width={width || BEACON_PRO_RIGHT_CONTENT_WIDTH} />
    </SlColumn>
  );
};

export default SplineChartLoading;
